import { createContext, useContext } from 'react';

/**
 * Kontext des Zurück-Fängers. Liegt in `ui/`, damit die Bausteine ihn lesen können; der
 * Provider dazu liegt in `context/BackLayerProvider.js` — er braucht react-router, und
 * `ui/` bleibt Leaf-Library.
 */
export const BackLayerContext = createContext(null);

/** Null, wenn kein Provider montiert ist — Bausteine bleiben dann einfach ohne Fänger. */
export function useBackLayer() {
  return useContext(BackLayerContext);
}

/** Für Vollbild-Ebenen und den Toast: Kaskade und Stapel-Abfrage. */
export function useBackLayerManager() {
  const ctx = useContext(BackLayerContext);
  if (!ctx) throw new Error('useBackLayerManager benötigt <BackLayerProvider>.');
  return ctx;
}
